import { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignLeft } from '@fortawesome/free-solid-svg-icons';
import Navbar from 'reactstrap/es/Navbar';
import Button from 'reactstrap/es/Button';

class NavBar extends Component {
	state = {
		isOpen: false
	};

	render () {
		return (
			<Navbar light className="navbar shadow-sm p-3 mb-5 rounded" expand="md">
				<Button color="info" onClick={this.props.toggle}>
					<FontAwesomeIcon icon={faAlignLeft} />
				</Button>
			</Navbar>
		);
	}
}

export default NavBar;
